(function () {
  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function clamp(n, min) {
    n = parseInt(n, 10);
    if (isNaN(n)) n = 0;
    return Math.max(min, n);
  }

  document.addEventListener('click', function (e) {
    const plus = e.target.closest('[data-mq-plus]');
    const minus = e.target.closest('[data-mq-minus]');
    if (!plus && !minus) return;

    const row = closest(e.target, '.mq-row');
    if (!row) return;

    const input = row.querySelector('.mq-input');
    if (!input || input.disabled) return;

    let val = clamp(input.value, 0);
    val = plus ? val + 1 : Math.max(0, val - 1);
    input.value = val;
  });

  // Intercept product form submit if multi-qty table exists
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form || !form.matches('form[action^="/cart/add"]')) return;

    const mq = form.querySelector('[data-mq]');
    if (!mq) return; // no multi-qty table on this product

    // Collect items
    const rows = mq.querySelectorAll('.mq-row');
    const items = [];

    rows.forEach((row) => {
      const available = row.getAttribute('data-available') === '1';
      const id = row.getAttribute('data-variant-id');
      const input = row.querySelector('.mq-input');
      const qty = input ? clamp(input.value, 0) : 0;

      if (available && id && qty > 0) {
        items.push({ id: Number(id), quantity: qty });
      }
    });

    if (!items.length) {
      // Nothing selected; let the normal form submit happen OR block it.
      // Most people prefer blocking with a message:
      e.preventDefault();
      alert('Please choose a quantity for at least one size.');
      return;
    }

    e.preventDefault();

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || 'Cart add failed');
      }

      // Simple success behaviour:
      window.location.href = '/cart';
    } catch (err) {
      console.error(err);
      alert('Sorry — something went wrong adding to cart.');
    }
  });
})();
